import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, onMounted } from "vue";
import MonthPicker from "@/components/picker/MonthPicker.vue";
import ShiftTable, { Shift, Date, Employee } from "./ShiftTable.vue";
import { $get, $post } from "@/plugins/api/api";
import { Paths } from "@/plugins/api/paths";
import { DateTime } from "luxon";

type Item = {
  value: number;
  text: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ShiftSearch',
  setup(__props) {

const affiliation = ref<number>();
const month = ref("");

const items = ref<Item[]>([]);

const interval = ref<Date[]>([]);
const shift = ref<Employee[]>([]);

const monthToDate = (date: string) => {
  const datetime = DateTime.fromFormat(date, "yyyy-MM");
  return datetime.isValid ? datetime.toFormat("yyyy-MM-dd") : "";
};

const dateToMonth = (date: string) => {
  const datetime = DateTime.fromFormat(date, "yyyy-MM-dd");
  return datetime.isValid ? datetime.toFormat("yyyy-MM") : "";
};

const day = computed(() => monthToDate(month.value));

const getAffiliation = async () => {
  const response = await $get<Item[]>(Paths.approval.shiftTable.affiliation);
  if (response) items.value = response;
};

const getClosingMonth = async () => {
  const response = await $get<string>(Paths.approval.shiftTable.closingMonth);
  if (response) month.value = dateToMonth(response);
};

const getShiftTable = async () => {
  const request = { affiliationId: affiliation.value, date: day.value };
  const response = await $post<Shift>(Paths.approval.shiftTable.post, request);
  if (response) {
    interval.value = response.interval;
    shift.value = response.shift;
  }
};

watch(items, val => {
  if (val.length > 0) affiliation.value = val[0]?.value;
});

const onSearch = async () => {
  await getShiftTable();
};

onMounted(async () => {
  await Promise.all([getAffiliation(), getClosingMonth()]);
  await onSearch();
});

return { __sfc: true,affiliation, month, items, interval, shift, monthToDate, dateToMonth, day, getAffiliation, getClosingMonth, getShiftTable, onSearch, MonthPicker, ShiftTable }
}

})